/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const StopCircleIcon: FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_3020_5617)">
      <path
        d="M7.99998 14.6666C11.6819 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6819 1.33325 7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33331 6.39992C5.33331 6.02655 5.33331 5.83987 5.40598 5.69726C5.46989 5.57182 5.57188 5.46983 5.69732 5.40591C5.83993 5.33325 6.02661 5.33325 6.39998 5.33325H9.59998C9.97335 5.33325 10.16 5.33325 10.3026 5.40591C10.4281 5.46983 10.5301 5.57182 10.594 5.69726C10.6666 5.83987 10.6666 6.02655 10.6666 6.39992V9.59992C10.6666 9.97329 10.6666 10.16 10.594 10.3026C10.5301 10.428 10.4281 10.53 10.3026 10.5939C10.16 10.6666 9.97335 10.6666 9.59998 10.6666H6.39998C6.02661 10.6666 5.83993 10.6666 5.69732 10.5939C5.57188 10.53 5.46989 10.428 5.40598 10.3026C5.33331 10.16 5.33331 9.97329 5.33331 9.59992V6.39992Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3020_5617">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
